import React from "react";
import "./home.css";
// import { Button, Container, Row, Col, InputGroup, InputGroupAddon, Input } from "reactstrap";
import { Container, Row, Col } from "reactstrap";
import Competences from "../../components/competences/competences";
import Summary from "../../components/summary/summary";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSearch } from "@fortawesome/free-solid-svg-icons";

function Home() {
  return (
    <div>
      <header id="home">
        <div className="bg-img">
          <div className="overlay"></div>
        </div>        
          <Container className="home-wrapper">
            <Row>
              <Col fluid="md">
                <div className="home-content">
                  <h1 className="text-light font50 letter-space-9p">Portal NSC Escola</h1>
                  <h3 className="text-light font20">Conteúdo do NSC Total organizado pela BNCCS para que você busque e prepare suas aulas com conteúdo rico e atualizado.</h3>
                  {/* <div className="m-2">
                    <Button color="primary" size="lg" className="mr-4">
                      Experimentar
                    </Button>
                    <Button color="warning" size="lg">
                      Saiba mais
                    </Button>
                  </div> */}
                </div>
              </Col>
            </Row>
            {/* <Row className="mt-5">
              <Col>
                <Container>
                  <InputGroup size="lg">
                    <Input placeholder="Digite sua pesquisa :) "/>
                    <InputGroupAddon addonType="prepend"><Button color="dark"> <FontAwesomeIcon icon={faSearch} size="lg" /></Button></InputGroupAddon>
                  </InputGroup>
                </Container>
              </Col>
            </Row> */}
          </Container>       
      </header>
      <Competences></Competences>
      <Summary></Summary>
    </div>
  );
}

export default Home;
